import { useState, useEffect, useCallback, useContext } from 'react';

import { useAxios } from './useAxios';
import AuthContext from '../contexts/AuthContext';

const REFRESH_EVENT = 'messagesRefresh';

export const useUnreadMessages = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const { token } = useContext(AuthContext);
  const { sendRequest } = useAxios();

  const refresh = useCallback(async () => {
    if (!token) {
      setUnreadCount(0);
      return;
    }
    try {
      const response = await sendRequest('/messages?isRead=false', 'GET', null, {
        Authorization: `Bearer ${token}`,
      });
      setUnreadCount(response?.messages?.length || 0);
    } catch (error) {
      setUnreadCount(0);
    }
  }, [token, sendRequest]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    const handler = () => refresh();
    window.addEventListener(REFRESH_EVENT, handler);
    return () => window.removeEventListener(REFRESH_EVENT, handler);
  }, [refresh]);

  useEffect(() => {
    const interval = setInterval(() => {
      refresh();
    }, 60000);

    return () => clearInterval(interval);
  }, [refresh]);

  return { unreadCount, refresh, refreshEventName: REFRESH_EVENT };
};
